import * as types from "./actionTypes";
import * as reportApi from "../../api/reportApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadReportsSuccess(reports) {
  return { type: types.LOAD_REPORTS_SUCCESS, reports };
}

export function passProfileOrEventOptimistic(id) {
  return { type: types.PASS_PROFILE_OR_EVENT_OPTIMISTIC, id };
}

export function failProfileOptimistic(id) {
  return { type: types.FAIL_PROFILE_OPTIMISTIC, id };
}

export function failEventOptimistic(id) {
  return { type: types.FAIL_EVENT_OPTIMISTIC, id };
}

export function loadReports(accessToken) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return reportApi
      .getReports(accessToken)
      .then(reports => {
        console.log(reports);
        dispatch(loadReportsSuccess(reports));
        return reports;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function passProfileOrEvent(accessToken, body) {
  return function (dispatch) {
    dispatch(passProfileOrEventOptimistic(body.id));
    return reportApi.passProfileOrEvent(accessToken, body);
  };
}

export function failProfile(accessToken, body) {
  return function (dispatch) {
    dispatch(failProfileOptimistic(body.id));
    return reportApi.failProfile(accessToken, body);
  };
}

export function failEvent(accessToken, body) {
  return function (dispatch) {
    dispatch(failEventOptimistic(body.id));
    return reportApi.failEvent(accessToken, body);
  };
}

export function getReportsByUser(accessToken) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return reportApi
      .getReportsByUser(accessToken)
      .then(reports => {
        console.log(reports);
        dispatch(loadReportsSuccess(reports));
        return reports;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}